var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6992",
    "data-name": "Rectangle 6992",
    width: 48,
    height: 48,
    transform: "translate(728 1215)",
    fill: "#e6e8f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_card_details",
    "data-name": "View card details",
    transform: "translate(-728 -1215)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27788",
    "data-name": "Group 27788",
    transform: "translate(51.316 212.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6990",
    "data-name": "Rectangle 6990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30894",
    "data-name": "Path 30894",
    d: "M713.459,1018.83l-1.731.01h-.01a.443.443,0,0,0-.159-.06,2.366,2.366,0,0,0-.348-.11c-.13-.04-.269-.07-.408-.1a1.052,1.052,0,0,0-.169-.04,4.791,4.791,0,0,0-.528-.08,6.722,6.722,0,0,0-.9-.06h-.01a6.222,6.222,0,0,0-.746.04,5.328,5.328,0,0,0-.557.08.127.127,0,0,0-.06.01,2.462,2.462,0,0,0-.259.06,1.615,1.615,0,0,0-.278.07,2.993,2.993,0,0,0-.428.12c-.079.03-.169.06-.259.1l-3,.01-17.946.1-.01-2.71,27.785-.15.01,1.84Z",
    fill: "#002c77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27789",
    "data-name": "Group 27789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_30892",
    "data-name": "Path 30892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30895",
    "data-name": "Path 30895",
    d: "M713.443,1012.425a1.708,1.708,0,0,0-1.717-1.7h0l-24.373.132a1.708,1.708,0,0,0-1.7,1.716v0l.013,2.433,27.792-.149Z",
    fill: "#ffb063"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27790",
    "data-name": "Group 27790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_30893",
    "data-name": "Path 30893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30896",
    "data-name": "Path 30896",
    d: "M701.8,1025.8v.01a6.276,6.276,0,0,0,.04.75,5.385,5.385,0,0,0,.08.56,2.571,2.571,0,0,0,.05.27c.03.14.07.27.11.4a1.581,1.581,0,0,0,.09.31,7.582,7.582,0,0,0,.53,1.24c.12.21.24.4.37.59a5.526,5.526,0,0,0,.4.55c.15.18.3.34.46.5l-1.97.01-14.5.08a1.7,1.7,0,0,1-1.72-1.7l-.05-8.81,16.37-.09,2.01-.01-.1.1a7.059,7.059,0,0,0-.9,1.1,6.249,6.249,0,0,0-.38.61,6.753,6.753,0,0,0-.5,1.17,2.352,2.352,0,0,0-.11.35c-.04.13-.07.27-.1.41a.853.853,0,0,0-.04.17,4.515,4.515,0,0,0-.08.53A6.694,6.694,0,0,0,701.8,1025.8Z",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6994",
    "data-name": "Rectangle 6994",
    width: 5.75,
    height: 2.17,
    transform: "translate(706.33 1024.71)",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30897",
    "data-name": "Path 30897",
    d: "M712.97,1030.35c.13-.12.26-.23.38-.35a.031.031,0,0,1-.01.02C713.22,1030.13,713.1,1030.25,712.97,1030.35Z",
    fill: "#ffb063"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_30898",
    "data-name": "Path 30898",
    d: "M717.87,1023.68a8.909,8.909,0,0,0-14.29-4.8,8.173,8.173,0,0,0-1.52,1.59,8.917,8.917,0,1,0,16.07,5.33A9.109,9.109,0,0,0,717.87,1023.68Zm-1.28,2.78a2.506,2.506,0,0,1-.04.27,2.434,2.434,0,0,1-.07.46,2.55,2.55,0,0,1-.05.27,2.284,2.284,0,0,1-.07.28,3.666,3.666,0,0,1-.15.47c-.06.19-.14.38-.22.57a6.833,6.833,0,0,1-.68,1.21,3.822,3.822,0,0,1-.39.51,3.968,3.968,0,0,1-.48.53,6.98,6.98,0,0,1-2.35,1.59,4.993,4.993,0,0,1-.68.25c-.14.05-.29.09-.44.13a2.555,2.555,0,0,1-.27.05,6.842,6.842,0,0,1-1.48.16,4.91,4.91,0,0,1-.77-.05,6.151,6.151,0,0,1-.73-.11h-.03a5.039,5.039,0,0,1-.52-.14,1.583,1.583,0,0,1-.31-.09c-.06-.02-.13-.05-.2-.07-.14-.05-.28-.11-.42-.17a7.064,7.064,0,0,1-1.64-1,1.239,1.239,0,0,1-.22-.18,2.531,2.531,0,0,1-.3-.27,2.12,2.12,0,0,1-.15-.15c-.16-.16-.31-.32-.46-.5a5.526,5.526,0,0,1-.4-.55,5.262,5.262,0,0,1-.37-.59,7.582,7.582,0,0,1-.53-1.24,1.581,1.581,0,0,1-.09-.31,1.548,1.548,0,0,1-.07-.23c-.01-.06-.03-.11-.04-.17a2.571,2.571,0,0,1-.05-.27,5.385,5.385,0,0,1-.08-.56,6.276,6.276,0,0,1-.04-.75v-.01a6.694,6.694,0,0,1,.06-.9,4.515,4.515,0,0,1,.08-.53.853.853,0,0,1,.04-.17,2.728,2.728,0,0,1,.1-.41,2.352,2.352,0,0,1,.11-.35,6.753,6.753,0,0,1,.5-1.17,6.249,6.249,0,0,1,.38-.61,4.652,4.652,0,0,1,.42-.57,6.042,6.042,0,0,1,.48-.53l.1-.1h.01a3.787,3.787,0,0,1,.42-.38,7.209,7.209,0,0,1,1.07-.73,6.864,6.864,0,0,1,1.03-.48c.09-.04.18-.07.26-.1a3.021,3.021,0,0,1,.43-.12,1.635,1.635,0,0,1,.28-.07,2.417,2.417,0,0,1,.26-.06.127.127,0,0,1,.06-.01c.19-.03.37-.06.56-.08a6.289,6.289,0,0,1,.75-.04h.01a6.8,6.8,0,0,1,.9.06,4.827,4.827,0,0,1,.53.08,1.039,1.039,0,0,1,.17.04,2.73,2.73,0,0,1,.41.1,2.351,2.351,0,0,1,.35.11.44.44,0,0,1,.16.06h.01a7.548,7.548,0,0,1,1,.44,6.013,6.013,0,0,1,.9.58,6.578,6.578,0,0,1,.8.7,5.821,5.821,0,0,1,.7.79v.01a6.013,6.013,0,0,1,.58.9v.01a4.6,4.6,0,0,1,.31.63,5.315,5.315,0,0,1,.22.6,1.586,1.586,0,0,1,.09.31,1.545,1.545,0,0,1,.07.23c.01.06.03.11.04.17a2.577,2.577,0,0,1,.05.27,5.042,5.042,0,0,1,.08.56,6.345,6.345,0,0,1,.04.76Q716.62,1026.13,716.59,1026.46Z",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6995",
    "data-name": "Rectangle 6995",
    width: 5.75,
    height: 2.17,
    transform: "translate(706.33 1024.71)",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30899",
    "data-name": "Path 30899",
    d: "M714.71,1023.64a.01.01,0,0,0-.01-.01,5.283,5.283,0,0,0-.59-1.13c0-.01,0-.01-.01-.01a4.876,4.876,0,0,0-.61-.75v-.01a1.146,1.146,0,0,0-.11-.11,6.051,6.051,0,0,0-1.72-1.2h-.01a5.871,5.871,0,0,0-4.94.03,5.9,5.9,0,1,0,5.44,10.46h.02a3.953,3.953,0,0,0,.34-.22c.16-.11.31-.22.46-.34.13-.12.26-.23.38-.35q.015,0,.03-.03a5.043,5.043,0,0,0,.72-.87.01.01,0,0,0,.01-.01,5.914,5.914,0,0,0,.54-.99.01.01,0,0,1,.01-.01,6.03,6.03,0,0,0,.45-2.29A5.964,5.964,0,0,0,714.71,1023.64Zm-8.38,3.24v-2.17h5.75v2.17Z",
    fill: "#ffb063"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6996",
    "data-name": "Rectangle 6996",
    width: 5.75,
    height: 2.17,
    transform: "translate(706.33 1024.71)",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30900",
    "data-name": "Path 30900",
    d: "M700.659,1043.361l4.657-7.678-3.058-1.858L697.6,1041.5a1.79,1.79,0,0,0,.6,2.459h0A1.79,1.79,0,0,0,700.659,1043.361Z",
    fill: "#3d72fc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f3b4016e2a0901f7ee9c4db251caedbe.svg";
export { ForwardRef as ReactComponent };